import { AfterViewInit, Component, ElementRef, NgZone, ViewChild } from "@angular/core";
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
// import { LoadingController } from "@ionic/angular";
@Component({
	selector: "tools-location-picker",
	templateUrl: "./location-picker.component.html",
	styleUrls: ["./location-picker.component.scss"],
})
export class LocationPickerComponent implements AfterViewInit {
	@ViewChild("mapContainer", { static: false }) gmap: ElementRef;
	map: google.maps.Map;
	markers: google.maps.Marker[] = [];
	autocomplete: any;
	GoogleAutocomplete: any;
	GooglePlaces: any;
	geocoder: any;
	autocompleteItems: any;
	nearbyItems: any = new Array<any>();
	loading: any;

	lat = -26.061351;
	lng = 28.153786;

	coordinates = new google.maps.LatLng(this.lat, this.lng);

	mapOptions: google.maps.MapOptions = {
		center: this.coordinates,
		zoom: 11,
		scaleControl: false,
		streetViewControl: false,
		fullscreenControl: false,
		mapTypeControl: false,
		minZoom: 4,
		zoomControl: false,
	};

	constructor(public zone: NgZone, private tools: ToolsService) {
		// public loadingCtrl: LoadingController
		this.geocoder = new google.maps.Geocoder();
		this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
		this.autocomplete = {
			input: "",
		};
		this.autocompleteItems = [];
		this.markers = [];
		// this.loading = this.loadingCtrl.create();
	}

	ngAfterViewInit() {
		this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
		// Custom scroll zoom logic
		const mapContainer = document.getElementById('map'); // Ensure this ID is correct
		if (mapContainer) {
		  mapContainer.addEventListener('wheel', (event: WheelEvent) => this.tools.handleZoom(event, this.map));
		}
	}

	updateSearchResults() {
		if (this.autocomplete.input == "") {
			this.autocompleteItems = [];
			return;
		}
		this.GoogleAutocomplete.getPlacePredictions({ input: this.autocomplete.input }, (predictions) => {
			this.autocompleteItems = [];
			this.zone.run(() => {
				predictions.forEach((prediction) => {
					this.autocompleteItems.push(prediction);
				});
			});
		});
	}

	ClearAutocomplete() {
		this.autocompleteItems = [];
		this.autocomplete.input = "";
	}

	selectSearchResult(item) {
		this.clearMarkers();
		this.autocompleteItems = [];

		this.geocoder.geocode({ placeId: item.place_id }, (results, status) => {
			if (status === "OK" && results[0]) {
				// let position = {
				//     lat: results[0].geometry.location.lat,
				//     lng: results[0].geometry.location.lng
				// };
				const marker = new google.maps.Marker({
					position: results[0].geometry.location,
					map: this.map,
				});
				this.markers.push(marker);
				this.map.setCenter(results[0].geometry.location);
			}
		});
	}

	clearMarkers() {
		for (let i = 0; i < this.markers.length; i++) {
			this.markers[i].setMap(null);
		}
		this.markers = [];
	}
}
